import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { connectMediaStore } from '../../../_hocs/withOwnReduxStore';
import { compose } from 'redux';
import { Trans, withTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import DeviationGrid from '../../DeviationGrid';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { moveDeviationToPosition } from '../../../actions';
import withCurrentGallectionDeviations from '../../../_hocs/withCurrentGallectionDeviations';
import withSelectedDeviations from '../../../_hocs/withSelectedDeviations';
import withCurrentGallection from '../../../_hocs/withCurrentGallection';
import withGallections from '../../../_hocs/withGallections';
import withCurrentSubfolder from '../../../_hocs/withCurrentSubfolder';
import withCurrentGallectionSubfolders from '../../../_hocs/withCurrentGallectionSubfolders';
import { isSpecialFullyLockedFolder, canGallectionHaveSubfolders, getCanEditGallection } from '../../../helpers';
import AddDeviationsButton from '../../../_partials/AddDeviationsButton';
import AddGallectionButton from '../../../_partials/AddGallectionButton';
import ManageableDeviation from '../../../_partials/ManageableDeviation';
import ManageableSelectedItemsPanel from '../../../_partials/ManageableSelectedItemsPanel';
import { isPremiumGallection } from '../../../../utils/gallections';
import SubmitDeviationsButton from '../../../_partials/SubmitDeviationsButton';
import { normalizePremiumFolderData } from '../../../../utils/normalizePremiumFolderData';
import ManageableSubfolderSlider from '../../../_partials/ManageableSubfolderSlider';
import { GallectionType } from '../../../../types/gallection';
import gallectionDeviationManagerStyles from './GallectionDeviationManager.scss';
const enhance = compose(withCurrentGallection, withCurrentSubfolder, withCurrentGallectionSubfolders, withCurrentGallectionDeviations, withSelectedDeviations, withGallections, connectMediaStore(null, {
    moveDeviationToPosition
}), withTranslation());
export class GallectionDeviationManager extends React.Component {
    render() {
        const { currentGallection, currentSubfolderId, selectedCount, sideBarContent, subfolders } = this.props;
        const showSubtitle = !isSpecialFullyLockedFolder(currentGallection) && getCanEditGallection(currentGallection) && selectedCount < 1 && subfolders.length < 1;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PopupInnerLayout, {
            headerSubtitle: showSubtitle ? this.getSubtitle() : undefined,
            headerExtrasRightZone: this.renderRightZoneButtons(),
            headerExtrasBottomZone: /*#__PURE__*/ React.createElement(React.Fragment, null, !currentSubfolderId && /*#__PURE__*/ React.createElement(ManageableSubfolderSlider, null), /*#__PURE__*/ React.createElement(ManageableSelectedItemsPanel, null)),
            scrollableContent: this.renderContent(),
            sideBarContent: sideBarContent,
            onScrolledToBottom: this.fetchMoreGallectionDeviationsIfNeeded,
            onNotScrollable: this.fetchMoreGallectionDeviationsIfNeeded
        }));
    }
    getSubtitle() {
        const { t, currentGallection } = this.props;
        const { isPaidFolder, isWatchToAccess } = normalizePremiumFolderData(currentGallection === null || currentGallection === void 0 ? void 0 : currentGallection.premiumFolderData);
        if (isPaidFolder) {
            return t('mediapopup.editYourGalleryHint.paidFolder');
        }
        if (isWatchToAccess) {
            return t('mediapopup.editYourGalleryHint.watchersOnlyFolder');
        }
        switch(currentGallection === null || currentGallection === void 0 ? void 0 : currentGallection.type){
            case GallectionType.STASH:
                return t('mediapopup.editYourStashHint');
            case GallectionType.GALLERY:
                return t('mediapopup.editYourGalleryHint');
            case GallectionType.COLLECTION:
            default:
                return t('mediapopup.editYourCollectionHint');
        }
    }
    renderRightZoneButtons() {
        const { currentGallection, currentSubfolder } = this.props;
        return /*#__PURE__*/ React.createElement(Flex, {
            style: {
                gap: 16
            }
        }, canGallectionHaveSubfolders(currentGallection) && !currentSubfolder && /*#__PURE__*/ React.createElement(AddGallectionButton, {
            isSecondary: true
        }), this.renderPlusDeviationsButton());
    }
    renderPlusDeviationsButton(buttonView, plusOnly) {
        const { currentGallection, selectionLimit } = this.props;
        if ((currentGallection === null || currentGallection === void 0 ? void 0 : currentGallection.type) === 'stash' || !getCanEditGallection(currentGallection)) {
            return null;
        }
        if (isPremiumGallection(currentGallection)) {
            return /*#__PURE__*/ React.createElement(SubmitDeviationsButton, {
                buttonView: buttonView,
                plusOnly: plusOnly
            });
        }
        return /*#__PURE__*/ React.createElement(AddDeviationsButton, {
            plusOnly: plusOnly,
            disabled: !this.canManageThisGallectionContents(),
            limit: selectionLimit
        });
    }
    renderContent() {
        const { isInitialized, isFetching, hasMore, deviations } = this.props;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, isInitialized && (!deviations.length && !hasMore ? this.renderEmpty() : /*#__PURE__*/ React.createElement(DeviationGrid, {
            deviations: deviations,
            deviationRenderer: this.deviationRenderer,
            moveDeviationToPosition: this.props.moveDeviationToPosition
        })), (!isInitialized || isFetching) && /*#__PURE__*/ React.createElement(LoadingIndicator, {
            coverMode: !isInitialized,
            view: "daSymbol"
        }));
    }
    renderEmpty() {
        const { t, currentGallection } = this.props;
        const { isPremium, isPaidFolder, isWatchToAccess } = normalizePremiumFolderData(currentGallection === null || currentGallection === void 0 ? void 0 : currentGallection.premiumFolderData);
        let headerTransKey = `mediapopup.addYourFirstDeviation.header.${currentGallection.type}`;
        let subheaderTransKey = `mediapopup.addYourFirstDeviation.subheader.${currentGallection.type}`;
        if (isPremium) {
            if (isPaidFolder) {
                headerTransKey = 'mediapopup.addYourFirstDeviation.header.premiumFolder.paid';
                subheaderTransKey = 'mediapopup.addYourFirstDeviation.subheader.premiumFolder.paid';
            }
            if (isWatchToAccess) {
                headerTransKey = 'mediapopup.addYourFirstDeviation.header.premiumFolder.watchersOnly';
                subheaderTransKey = 'mediapopup.addYourFirstDeviation.subheader.premiumFolder.watchersOnly';
            }
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: gallectionDeviationManagerStyles['empty-state-container']
        }, this.renderPlusDeviationsButton('b3', true), /*#__PURE__*/ React.createElement("div", {
            className: gallectionDeviationManagerStyles['empty-state-header']
        }, t(headerTransKey)), /*#__PURE__*/ React.createElement("div", {
            className: gallectionDeviationManagerStyles['empty-state-sub-header']
        }, /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: subheaderTransKey
        }, "Add your first deviation")));
    }
    constructor(...args){
        super(...args), _define_property(this, "canManageThisGallectionContents", ()=>{
            const { currentGallection, currentSubfolder } = this.props;
            const currentTopLevelGallectionOrSubfolder = currentSubfolder || currentGallection;
            const canManageContents = currentTopLevelGallectionOrSubfolder && !isSpecialFullyLockedFolder(currentTopLevelGallectionOrSubfolder);
            return canManageContents;
        }), _define_property(this, "fetchMoreGallectionDeviationsIfNeeded", ()=>{
            const { hasMore, isFetching, fetchMoreGallectionDeviations } = this.props;
            if (!hasMore || isFetching) {
                return;
            }
            fetchMoreGallectionDeviations();
        }), _define_property(this, "deviationRenderer", (deviation, index, deviations)=>{
            return /*#__PURE__*/ React.createElement(ManageableDeviation, {
                index: index,
                deviation: deviation
            });
        });
    }
}
export default enhance(GallectionDeviationManager);

//# sourceMappingURL=GallectionDeviationManager.js.map